import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Form from "./Form";
import { useForm } from "react-hook-form";

const DialogCreateFrom = ({ visible, handleClose }) => {
  const form = useForm();
  const { handleSubmit, reset } = form;

  const onSubmit = (updated) => {
    console.log(updated);
    handleClose();
  };

  useEffect(() => {
    reset();
  }, [reset, visible]);

  return (
    <Dialog open={visible} onClose={handleClose}>
      <DialogTitle>New</DialogTitle>
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <DialogContentText>
            Please enter all required fields.
          </DialogContentText>
          <Form form={form} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Create</Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

DialogCreateFrom.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
};

DialogCreateFrom.defaultProps = {
  visible: false,
  handleClose: () => {},
};

export default DialogCreateFrom;
